/**
 * The copy of the AT&T storefront access gate, as `StorefrontAccess.*` message IDs; the strings
 * live in `src/locale/translations/en/StorefrontAccess.json`. One config so the copy changes in
 * one place.
 *
 * There is no apply action: approvals happen off-platform, so the gate offers no on-site
 * application path. The Key Buyer line is inline text until the Key Buyer status epic ships a
 * page; setting `keyBuyerLine.linkUrl` then turns the same text into a link to it.
 */
export type StorefrontAccessGateContent = {
  headingId: string
  bodyId: string
  keyBuyerLine: {
    textId: string
    linkUrl?: string
  }
}

export const STOREFRONT_ACCESS_GATE_CONTENT: StorefrontAccessGateContent = {
  headingId: 'StorefrontAccess.gate.heading',
  bodyId: 'StorefrontAccess.gate.body',
  keyBuyerLine: {
    textId: 'StorefrontAccess.gate.keyBuyerLine',
  },
}
